module.exports = __webpack_public_path__ + "media/promo/courses/images/tomato-a67427988bff9989ca43380a33cdf92a.png";